import { defineMessages } from 'react-intl'

const scope = 'app.components.BusinessesFilters'

export const subjectsMessages = defineMessages({
  resolver: {
    id: `${scope}.subjects.resolver`,
    defaultMessage: 'Resolver',
  },
  businessName: {
    id: `${scope}.subjects.businessName`,
    defaultMessage: 'Resolver',
  },
  businessType: {
    id: `${scope}.subjects.businessType`,
    defaultMessage: 'Industry',
  },
  businessAddress: {
    id: `${scope}.subjects.businessAddress`,
    defaultMessage: 'Address',
  },
  untaxedIncome: {
    id: `${scope}.subjects.untaxedIncome`,
    defaultMessage: 'Untaxed Revenue',
  },
  easeOfCollection: {
    id: `${scope}.subjects.easeOfCollection`,
    defaultMessage: 'Ease of Collection',
  },
  status: {
    id: `${scope}.subjects.status`,
    defaultMessage: ' ',
  },
  businessCategory: {
    id: `${scope}.subjects.businessCategory`,
    defaultMessage: 'Resolver',
  },
  creatorType: {
    id: `${scope}.subjects.creatorType`,
    defaultMessage: 'Creator Type',
  },
  employessInJurisdiction: {
    id: `${scope}.subjects.employessInJurisdiction`,
    defaultMessage: 'Employess In Jurisdtiction',
  },
  locationInJurisdiction: {
    id: `${scope}.subjects.locationInJurisdiction`,
    defaultMessage: 'Locations In Jurisdtiction',
  },
})

export const optionsMessages = defineMessages({
  gig: {
    id: `${scope}.options.gig`,
    defaultMessage: 'Gig Economy',
  },
  ecommerce: {
    id: `${scope}.options.ecommerce`,
    defaultMessage: 'E-Commerce',
  },
  nexus: {
    id: `${scope}.options.nexus`,
    defaultMessage: 'Nexus',
  },
  google: {
    id: `${scope}.options.google`,
    defaultMessage: 'Google Ads',
  },
  yelp: {
    id: `${scope}.options.yelp`,
    defaultMessage: 'Yelp',
  },
  craigslist: {
    id: `${scope}.options.craigslist`,
    defaultMessage: 'Craigslist',
  },
})
